import React from 'react';
import { Typography, Grid, Container, Button, Box, Card, Divider, Badge } from '@mui/material';


const Block4 = (props) => {
    const trademarkSymbol = '\u2122';
    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={'xl'}
            sx={{
                marginTop: "80px",
                marginBottom: "40px"
            }}
        >
            <Divider sx={{ margin: "25px" }} />
            <Grid container item md={12} justifyContent={'center'} direction={'row'} alignItems={'flex-start'}>
                <Grid container item md={4}>
                    <Grid container item md={2} />
                    <Grid container item md={10} justifyContent={'flex-start'} direction={'column'}

                        alignItems={{
                            xs: "center",
                            md: 'flex-start'
                        }}
                    >

                        <Button disableElevation variant='contained' size="large"
                            sx={{
                                backgroundColor: "#FFEAE6",
                                marginRight: "10px", color: "#FE753E",
                                fontWeight: "bold", borderRadius: "50px"
                            }}>
                            Alerts
                        </Button>
                        <Typography
                            variant={'h1'}
                            sx={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                marginTop: "25px"
                            }}
                        >
                            Tirefax Safety Alerts
                            {/* Tirefax Safety Alerts<sup style={{ fontSize: "18px" }}>{trademarkSymbol}</sup> */}
                        </Typography>
                    </Grid>
                    <Grid container item md={1} />
                </Grid>
                <Grid item md={7} justifyContent={'center'}
                    alignItems={{
                        xs: "center",
                        md: 'flex-start'
                    }}
                >
                    <Typography
                        align='justify'
                        sx={{
                            fontSize: "20px",
                            color: "#808291",
                            margin: "20px 25px 20px 10px",

                        }}
                    >
                        With a simple scan of the tires TIN using any smartphone or tablet, Tirefax instantly identifies up to (12) potential ‘tire safety issues’ in seconds – that’s four times more than (3) ‘tire safety issues’ most servicers or mechanics are able to identify today! In addition, Tirefax provides all OEM tire replacement options.
                    </Typography>
                </Grid>
            </Grid>

        </Container>
    )
}

export default Block4;